import { useCallback } from 'react'
import { useAuth } from './auth/auth-context'

const isDev = process.env.NODE_ENV === 'development'


const useFetch = () => {
    const { getToken, logout } = useAuth()

    const doFetch = useCallback(async (path: string, body?: any, method?: string) => {
        try {
            const token = getToken()
            const isFormData = body instanceof FormData

            const headers:Record<string, string> = {
                Authorization: `${token}`,
            }
            if(!isFormData) headers['Content-Type'] = 'application/json'
            const origin = isDev ? 'http://localhost:3050' : 'https://api.affdash.nordpar.com'
            const url = origin + path
            
            const newBody = body ? isFormData ? body : JSON.stringify(body) : undefined
            
            const defaultMethod = newBody ? 'POST' : 'GET'
            const opts: RequestInit = { method: method || defaultMethod }
            if (newBody) opts.body = newBody
            
            const response = await fetch(url, { headers, ...opts })
            
            if(response.status === 401) {
                logout()
                await new Promise(r => {})
            }
            
            return response
        } catch (error) {
            throw error
        }
    }, [getToken, logout])

    return { doFetch }
}

export default useFetch
